const releaseInfo = {
    buildId: '1.6.15',
    name: 'Atlas',
    commit: 'c0d346a7e68ea180d1567465817f30a49fd19593'
};
export default releaseInfo;
